module.exports = __webpack_public_path__ + "images/help/new_feature_goukuai_1027-84514a17e200261b0d2bf66bc45fc865.png";